import { useState, type FormEvent } from "react";
import { Link, Navigate } from "react-router";
import { Alert, Button, Field } from "../components/ui";
import { api, errorMessage } from "../lib/api";
import { storedBranding, storedCompanyCode } from "../lib/company";
import { CompanyMark } from "./Login";

/** « Mot de passe oublié » : la société est celle que le téléphone a retenue. */
export function PasswordForgotPage() {
  const code = storedCompanyCode();
  const branding = storedBranding();
  const [login, setLogin] = useState(() => localStorage.getItem("tp:last-username") ?? "");
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  // Sans société retenue, la connexion demande d'abord le code.
  if (!code) return <Navigate to="/login" replace />;

  async function submit(e: FormEvent) {
    e.preventDefault();
    if (loading) return;
    setError(null);
    setLoading(true);
    try {
      await api("/public/password-reset", { method: "POST", body: { company: code, login: login.trim() } });
      setSent(true);
    } catch (err) {
      setError(errorMessage(err));
    } finally {
      setLoading(false);
    }
  }

  return (
    <main className="login">
      {branding ? <CompanyMark branding={branding} /> : <img className="login-logo" src="/icons/icon.svg" alt="" width={72} height={72} />}
      <h1>Mot de passe oublié</h1>
      {sent ? (
        <div className="form" style={{ marginTop: 20 }}>
          <Alert kind="info">
            Si un compte correspond, un e-mail vient de partir. Pas d'e-mail sur votre compte ? Demandez à votre responsable.
          </Alert>
        </div>
      ) : (
        <>
          <p className="text-2" style={{ marginTop: 6, marginBottom: 28 }}>
            Saisissez votre identifiant ou votre e-mail : nous vous envoyons un lien pour choisir un nouveau mot de passe.
          </p>
          <form className="form" onSubmit={submit} noValidate>
            {error && <Alert kind="error">{error}</Alert>}
            <Field label="Identifiant ou e-mail" htmlFor="login">
              <input
                id="login"
                className="input"
                autoComplete="username"
                autoCapitalize="none"
                autoCorrect="off"
                spellCheck={false}
                enterKeyHint="send"
                value={login}
                onChange={(e) => setLogin(e.target.value)}
                required
              />
            </Field>
            <Button type="submit" variant="primary" size="large" block loading={loading} disabled={!login.trim()}>
              Envoyer le lien
            </Button>
          </form>
        </>
      )}
      <p className="small" style={{ textAlign: "center", marginTop: 20 }}>
        <Link to="/login">Revenir à la connexion</Link>
      </p>
    </main>
  );
}
